/* unplugin-vue-components disabled */import { render } from "./skills-list.vue?vue&type=template&id=19d5f46f&scoped=true"
import script from "./skills-list.vue?vue&type=script&lang=js"
export * from "./skills-list.vue?vue&type=script&lang=js"

import "./skills-list.vue?vue&type=style&index=0&id=19d5f46f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d5f46f"],['__file',"src/pages/settings/admin/test-skills/skills-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19d5f46f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19d5f46f', __exports__)) {
    api.reload('19d5f46f', __exports__)
  }
  
  module.hot.accept("./skills-list.vue?vue&type=template&id=19d5f46f&scoped=true", () => {
    api.rerender('19d5f46f', render)
  })

}


export default __exports__